import { Routes } from '@angular/router';
import {
	PublicPagesWrapperComponent
} from '@infodocs/shared/components/public-pages-wrapper/public-pages-wrapper.component';

// public appRoutes do not prepend "/public"
export const publicRoutes: Routes = [
	{
		path: 'demo/checkout',
		loadComponent: () => import('./pages/demo-page/checkout/demo-checkout-page.component').then(m => m.DemoCheckoutPageComponent)
	},
	{
		path: 'search',
		loadComponent: () => import('./pages/search-page/search-page.component').then(m => m.SearchPageComponent)
	},
	{
		path: '',
		component: PublicPagesWrapperComponent,
		children: [
			{
				path: '',
				loadComponent: () => import('../account/pages/register-page/register-page.component').then(m => m.RegisterPageComponent)
			},
			{
				path: 'annual-return',
				loadComponent: () => import('./pages/annual-return-page/annual-return-page.component').then(m => m.AnnualReturnPageComponent)
			},
			{
				path: 'compliance-checklist',
				loadComponent: () => import('./pages/compliance-checklist-page/compliance-checklist-page.component').then(m => m.ComplianceChecklistPageComponent)
			},
			{
				path: 'compliance-checklist-ccfo',
				loadComponent: () => import('./pages/compliance-checklist-ccfo-page/compliance-checklist-ccfo-page.component').then(m => m.ComplianceChecklistCcfoPageComponent),
				data: { headerType: 'ccfo' }
			},
			{
				path: 'public-interest-score',
				loadComponent: () => import('./pages/public-interest-score-page/public-interest-score-page.component').then(m => m.PublicInterestScorePageComponent)
			},
			{
				path: 'cipc-noncompliance-april-2026',
				loadComponent: () => import('./pages/cipc-noncompliance-20250110-page/cipc-noncompliance-20250110-page.component').then(m => m.CipcNoncompliance20250110PageComponent)
			},
			{
				path: 'cipc-noncompliance-january-2025',
				redirectTo: 'cipc-noncompliance-april-2026',
				pathMatch: 'full',
			},
			{
				path: 'cipc-noncompliance-legalese',
				loadComponent: () => import('./pages/cipc-noncompliance-legalese-page/cipc-noncompliance-legalese-page.component').then(m => m.CipcNoncomplianceLegalesePageComponent),
				data: { headerType: 'legalese' }
			},
			{
				path: 'demo',
				loadComponent: () => import('./pages/demo-page/demo-page.component').then(m => m.DemoPageComponent),
				data: { headerType: 'withLogin' }
			},
			// TEMP: Only show verify route when enableVerifyRoute is true (staging, UAT, local, etc.)
			// TEMP: temporarily disabled
			// ...(environment.enableVerifyRoute
			// 	? [
			// 		{
			// 			path: 'verify',
			// 			loadComponent: () => import('./pages/intergreatme-verify-page/intergreatme-verify-page.component').then(m => m.IntergreatmeVerifyPageComponent)
			// 		}
			// 	]
			// 	: []),
			{
				path: '**',
				loadComponent: () => import('./pages/error-page/error-page.component').then(m => m.ErrorPageComponent),
				data: { headerType: 'withLogin' },
			},
		]
	},
];
